import jwt from 'jwt-decode';
import axios from 'axios';
import servicioObjetos from './ServicioObjetos';
import { BASE_URL } from './ServicioConstantes';

const TOKEN_KEY="CONSULTA_RECIBO_QUADRUM_TOKEN";
const USUARIO_KEY="CONSULTA_RECIBO_QUADRUM_USUARIO";
const BEARER="Bearer ";

var instanciaAxios = axios.create({  
    baseURL: BASE_URL
});

export function setToken(token) {   
    localStorage.setItem(TOKEN_KEY, token);
}

export function setUsuario(usuario){
    localStorage.setItem(USUARIO_KEY, usuario);
}

export function getUsuario(){
    return localStorage.getItem(USUARIO_KEY);
}

export function deleteToken(){
    localStorage.removeItem(TOKEN_KEY);    
}

export function deleteUsuario(){
    localStorage.removeItem(USUARIO_KEY);
}

export function getToken() {
    return new Promise((resolve, reject) => {
        let tokenLocalStorage = localStorage.getItem(TOKEN_KEY);        
        if (!servicioObjetos.esObjetoVacio(tokenLocalStorage)) {
            let tokenDecodificado = jwt(tokenLocalStorage.replace(BEARER, ""));
            let expiracionToken = new Date(tokenDecodificado.exp * 1000);
            let ahora = new Date();
            if (expiracionToken < ahora) {                
                let usuario = getUsuario();
                let refreshToken = tokenDecodificado.jti;
                instanciaAxios.post('/renovar.json?usuario=' + usuario + '&refreshToken=' + refreshToken,null).then(response => {
                    let token = response.headers.authorization;
                    setToken(token);
                    resolve(token);
                }).catch(error => {                    
                    reject(error);
                });
            }else{                
                resolve(tokenLocalStorage);
            }
        } else {
            resolve(null);
        }
    });
}